var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCcSecure = function SvgCcSecure(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "e18g6eeu6a",
    colorInterpolationFilters: "auto"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.149020 0 0 0 0 0.815686 0 0 0 0 0.486275 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#e18g6eeu6a)",
    transform: "translate(-1041.000000, -237.000000) translate(56.000000, 229.000000) translate(977.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H16V16H0z",
    transform: "translate(8.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#25253A",
    fillRule: "nonzero",
    d: "M7.766.71l-5.333 2c-.26.097-.433.345-.433.623V8c0 1.98 1.097 3.763 2.894 5.335.613.536 1.266 1.01 1.92 1.418l.364.221.299.17.225.119c.188.094.408.094.596 0l.225-.119.3-.17.235-.142.129-.08c.653-.408 1.306-.881 1.919-1.417C12.903 11.763 14 9.98 14 8V3.333c0-.278-.172-.526-.433-.624l-5.333-2c-.15-.056-.317-.056-.468 0zM8 2.044l4.667 1.75V8c0 1.52-.903 2.987-2.44 4.332-.554.485-1.15.917-1.747 1.29l-.3.183-.18.103-.18-.103-.3-.183c-.597-.373-1.193-.805-1.748-1.29l-.174-.156C4.168 10.875 3.333 9.462 3.333 8V3.795L8 2.045z",
    transform: "translate(8.000000, 8.000000)"
  }))))))));
};
export default SvgCcSecure;